




















































































































import AbpBase from "../../../lib/abpbase";
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import multipleDataEchart from '../../../components/charts/multipleDataEchart.vue'
import Util from '../../../lib/util'
import {SaveBDialyWeight,GetPatBeforeDryWeightData,GetPatBeforeHistData,GetPatBeforeHistBpData} from '../../../api/dialysisProcess'
import util from "../../../lib/util";

@Component({
     components:{multipleDataEchart}
})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
    weightChart:any = {
        type:'line',
        legendName:['称量体重'],
        name:'weight'
    }
    weightChart2 = {
        type:'line',
        legendName:['收缩压','舒张压'],
        name:'bp'
    }
    //历史数据
    x_hisDataShow = false
    t_hisDataShow = false
    //表单值
    roleRule = {
        beforeWeight:[{required: false,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        beforeSbp:[{required:false,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        beforeDbp:[{required:false,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        heartRate:[{required:false,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        temperature:[{required:false,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        isLayUp:[{required:false,message:this.L('FieldIsRequired'),trigger: 'blur'}],
        remarks:[{required:false,message:this.L('FieldIsRequired'),trigger: 'blur'}],
    }
    show = false
    form:any = {
        patientId:this.data.patientId,
        beforeWeight:null,
        beforeSbp:null,
        beforeDbp:null,
        heartRate:null,
        temperature:36.5,
        isLayUp:'false',
        remarks:''
    }
    dryWeight = ''
    //获取干体重
    async getPatBeforeDryWeightData(){
        let data = {
            DialysisWay:this.data.dialysisWay.split('/')[0] || this.data.dialysisWay,
            PatientId:this.data.patientId
        }
        let res = await GetPatBeforeDryWeightData(data)
        this.dryWeight = res.objects.dryWeight
    }
    created() {
        this.getPatBeforeDryWeightData()
    }
    
    save(){
        (this.$refs.roleForm as any).validate(async (valid:boolean)=>{
            if(valid){
                console.log(this.data)
                this.saveBDialyWeight(this.form)
            }
        })
    }
    async saveBDialyWeight(data:any){
        let res = await SaveBDialyWeight(data)
        if(res.status == 1){
            // this.$Message.success('保存成功')
            this.$emit('input',false);
            this.$emit('on-success')
        }else{
            // this.$Message.error(res.message)
        }
    }

    mounted() {
        // this.weightHisChange(this.weightPeriod)
        // this.getWeightHis()
    }
    cancel(){
        (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/waitRoom/weightForm.vue